import React from 'react';

class CustomToggle extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <div style={{ paddingRight: '12px' }}>
        <a href="" onClick={this.handleClick} style={{ outline: 'none' }}>
          {this.props.children}
        </a>
      </div>
    );
  }
}

export default CustomToggle;


// WEBPACK FOOTER //
// ./src/components/CustomToggle.js